import { render } from "./apconf.vue?vue&type=template&id=58dc93fd&scoped=true"
import script from "./apconf.vue?vue&type=script&lang=js"
export * from "./apconf.vue?vue&type=script&lang=js"

import "./apconf.vue?vue&type=style&index=0&id=58dc93fd&scoped=true&lang=css"

import exportComponent from "G:\\zhongfu\\web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58dc93fd"]])

export default __exports__